var _excluded = ["autoHeight", "children", "className", "hideRequired", "iconLeft", "iconLeftCallback", "iconRight", "iconRightCallback", "id", "inputRef", "isLabelInline", "isNumberInput", "label", "maxHeight", "minHeight", "requiredLabel", "rows", "shouldHideLabel", "size", "toolbar", "isSelectBox", "isTextArea"],
  _excluded2 = ["id", "children", "countThreshold", "className", "errorMessageMap", "isTextArea", "label", "max", "messages", "min", "onMountValidation", "onlyValidateWhenTouched", "readOnly", "shouldHideErrorMessage", "showCount", "characterCounter", "validator", "value", "onBlur"];
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useRef, Children, Component } from 'react';
import { createEnum, ValidPropTypes, makeErrorBoundComponent, appendClass, generateId } from '@els/els-react--utils';
import PT from 'prop-types';
import { Icon } from '@els/els-react--icon';
import Case from 'case';
import classnames from 'classnames';
var TextInputSizes = createEnum(['small', 'large']);

// eslint-disable-next-line import/prefer-default-export
var DefaultMessages = createEnum({
  error: 'Error',
  maxErrorMessage: 'Value has too many characters.',
  minErrorMessage: 'Value has too few characters.',
  requiredErrorMessage: 'This field is required.',
  alphanumericErrorMessage: 'Value must be alphanumeric.',
  alphaErrorMessage: 'Value must contain only letters.',
  numericErrorMessage: 'Value must only contain numbers.',
  emailErrorMessage: 'Value must be valid email address.'
});
var TextInputMessageTypes = createEnum(['default', 'success', 'error', 'warning']);
var node$3 = PT.node,
  oneOf$1 = PT.oneOf,
  object$2 = PT.object,
  string$4 = PT.string;
var defaults$2 = {
  className: "",
  type: TextInputMessageTypes.DEFAULT,
  id: "",
  messages: DefaultMessages
};
var TextInputMessage = function TextInputMessage(_ref) {
  var children = _ref.children,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? defaults$2.className : _ref$className,
    _ref$messages = _ref.messages,
    messages = _ref$messages === void 0 ? defaults$2.messages : _ref$messages,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? defaults$2.type : _ref$type,
    _ref$id = _ref.id,
    id = _ref$id === void 0 ? defaults$2.id : _ref$id;
  var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
  var classes = classnames("c-els-field__message", className, {
    "c-els-field__message--success": type === TextInputMessageTypes.SUCCESS,
    "c-els-field__message--error": type === TextInputMessageTypes.ERROR,
    "c-els-field__message--warning": type === TextInputMessageTypes.WARNING
  });
  return id ? /* @__PURE__ */React.createElement("span", {
    id: id,
    className: classes,
    "data-testid": "text-input-message"
  }, type === TextInputMessageTypes.ERROR ? /* @__PURE__ */React.createElement(Icon, {
    className: "c-els-field__message-icon",
    sprite: Icon.Sprites.ALERT_SOLID_SQUARE,
    color: Icon.Colors.NEGATIVE,
    textAlignment: Icon.TextAlignment.OFFSET,
    size: Icon.Sizes.S,
    fallback: (/* istanbul ignore next */
    function fallback() {
      return "!";
    })
  }, compiledMessages.ERROR) : null, children) : /* @__PURE__ */React.createElement("span", {
    className: classes,
    "data-testid": "text-input-message"
  }, children);
};
TextInputMessage.displayName = "TextInputMessage";
TextInputMessage.propTypes = {
  /** The actual message to be displayed */
  children: node$3.isRequired,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string$4,
  /** Accessibilty - (Screen Readers) require Input fields to be
   * linked by aria-describedby and id to read the related text. */
  id: string$4,
  messages: object$2,
  /** One of the values defined as a message type */
  type: oneOf$1(Object.values(TextInputMessageTypes))
};
TextInputMessage.requiredProps = {
  children: ValidPropTypes.NODE
};
TextInputMessage.defaults = defaults$2;
TextInputMessage.Types = TextInputMessageTypes;
TextInputMessage.DefaultMessages = DefaultMessages;
var RawTextInputMessage = TextInputMessage;
var TextInputMessage$1 = makeErrorBoundComponent(RawTextInputMessage);
var bool$3 = PT.bool,
  func$2 = PT.func,
  node$2 = PT.node,
  number$3 = PT.number,
  object$1 = PT.object,
  shape$1 = PT.shape,
  string$3 = PT.string;
var defaults$1 = {
  autoHeight: false,
  children: null,
  className: "",
  hideRequired: false,
  iconLeftCallback: null,
  iconLeft: null,
  iconRightCallback: null,
  iconRight: null,
  id: null,
  inputRef: null,
  isLabelInline: false,
  isNumberInput: false,
  // Also set in CSS
  maxHeight: "50vh",
  minHeight: null,
  onChange: null,
  size: null,
  shouldHideLabel: false,
  required: false,
  rows: 3,
  isSelectBox: false,
  isTextArea: false,
  requiredLabel: "Required",
  readOnly: false,
  toolbar: null
};
var TextInput = function TextInput(_ref2) {
  var _ref2$autoHeight = _ref2.autoHeight,
    autoHeight = _ref2$autoHeight === void 0 ? defaults$1.autoHeight : _ref2$autoHeight,
    _ref2$children = _ref2.children,
    children = _ref2$children === void 0 ? defaults$1.children : _ref2$children,
    _ref2$className = _ref2.className,
    className = _ref2$className === void 0 ? defaults$1.className : _ref2$className,
    _ref2$hideRequired = _ref2.hideRequired,
    hideRequired = _ref2$hideRequired === void 0 ? defaults$1.hideRequired : _ref2$hideRequired,
    _ref2$iconLeft = _ref2.iconLeft,
    iconLeft = _ref2$iconLeft === void 0 ? defaults$1.iconLeft : _ref2$iconLeft,
    _ref2$iconLeftCallbac = _ref2.iconLeftCallback,
    iconLeftCallback = _ref2$iconLeftCallbac === void 0 ? defaults$1.iconLeftCallback : _ref2$iconLeftCallbac,
    _ref2$iconRight = _ref2.iconRight,
    iconRight = _ref2$iconRight === void 0 ? defaults$1.iconRight : _ref2$iconRight,
    _ref2$iconRightCallba = _ref2.iconRightCallback,
    iconRightCallback = _ref2$iconRightCallba === void 0 ? defaults$1.iconRightCallback : _ref2$iconRightCallba,
    _ref2$id = _ref2.id,
    id = _ref2$id === void 0 ? defaults$1.id : _ref2$id,
    _ref2$inputRef = _ref2.inputRef,
    inputRef = _ref2$inputRef === void 0 ? defaults$1.inputRef : _ref2$inputRef,
    _ref2$isLabelInline = _ref2.isLabelInline,
    isLabelInline = _ref2$isLabelInline === void 0 ? defaults$1.isLabelInline : _ref2$isLabelInline,
    _ref2$isNumberInput = _ref2.isNumberInput,
    isNumberInput = _ref2$isNumberInput === void 0 ? defaults$1.isNumberInput : _ref2$isNumberInput,
    label = _ref2.label,
    _ref2$maxHeight = _ref2.maxHeight,
    maxHeight = _ref2$maxHeight === void 0 ? defaults$1.maxHeight : _ref2$maxHeight,
    _ref2$minHeight = _ref2.minHeight,
    minHeight = _ref2$minHeight === void 0 ? defaults$1.minHeight : _ref2$minHeight,
    _ref2$requiredLabel = _ref2.requiredLabel,
    requiredLabel = _ref2$requiredLabel === void 0 ? defaults$1.requiredLabel : _ref2$requiredLabel,
    _ref2$rows = _ref2.rows,
    rows = _ref2$rows === void 0 ? defaults$1.rows : _ref2$rows,
    _ref2$shouldHideLabel = _ref2.shouldHideLabel,
    shouldHideLabel = _ref2$shouldHideLabel === void 0 ? defaults$1.shouldHideLabel : _ref2$shouldHideLabel,
    _ref2$size = _ref2.size,
    size = _ref2$size === void 0 ? defaults$1.size : _ref2$size,
    _ref2$toolbar = _ref2.toolbar,
    toolbar = _ref2$toolbar === void 0 ? defaults$1.toolbar : _ref2$toolbar,
    _ref2$isSelectBox = _ref2.isSelectBox,
    isSelectBox = _ref2$isSelectBox === void 0 ? defaults$1.isSelectBox : _ref2$isSelectBox,
    _ref2$isTextArea = _ref2.isTextArea,
    isTextArea = _ref2$isTextArea === void 0 ? defaults$1.isTextArea : _ref2$isTextArea,
    inputProps = _objectWithoutProperties(_ref2, _excluded);
  if (iconLeft && !iconLeft.sprite || iconRight && !iconRight.sprite) {
    throw new Error("icon sprite must be provided.");
  }
  var wrapperClasses = classnames("c-els-field", className, {
    "c-els-field--inline": isLabelInline,
    "c-els-field--disabled": inputProps.disabled,
    // Select uses TextInput in readonly state, but not necessarily style.
    // When Select is readonly it applies its own --read-only modifier class, so don't want this one
    "c-els-field--read-only": inputProps.readOnly && !isSelectBox,
    "c-els-field--small": size === TextInputSizes.SMALL,
    "c-els-field--large": size === TextInputSizes.LARGE,
    "c-els-field--icon-left": iconLeft,
    "c-els-field--icon-right": iconRight,
    "c-els-field--has-toolbar": toolbar,
    "c-els-field--auto-height": autoHeight
  });
  var inputClasses = classnames("c-els-field__input", {
    "c-els-field--textarea": isTextArea
  }, appendClass({
    className: className,
    value: "input",
    delimiter: "__"
  }));
  var labelClasses = classnames("c-els-field__label", appendClass({
    className: className,
    value: "label",
    delimiter: "__"
  }));
  var labelTextClasses = classnames("c-els-field__label-text", appendClass({
    className: className,
    value: "label-text",
    delimiter: "__"
  }), {
    "u-els-hide-visually": shouldHideLabel
  });
  var inputID = id || Case.kebab("".concat(label, " ").concat(generateId()));
  var ref = inputRef || useRef();
  var blurInput = function blurInput() {
    ref.current.blur();
  };
  var textareaHeightStyles = {
    minHeight: minHeight || null,
    maxHeight: autoHeight && maxHeight ? maxHeight : null
  };
  var onKeyDownWrapper = function onKeyDownWrapper(event) {
    var input = event.target;
    if (autoHeight) {
      setTimeout(function () {
        input.style.height = "auto";
        input.style.height = "".concat(input.scrollHeight + 4, "px");
      });
    }
    if (inputProps.onKeyDown) inputProps.onKeyDown(event);
  };
  var sharedInputAttributes = {
    id: inputID,
    className: inputClasses,
    placeholder: shouldHideLabel ? label : "",
    "aria-labelledby": "".concat(inputID, "-label-text"),
    "data-testid": "text-input",
    ref: ref
  };
  var renderIcon = function renderIcon(iconProps, callback, alignment) {
    return (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      /* @__PURE__ */
      React.createElement(React.Fragment, null, callback ? /* @__PURE__ */React.createElement("button", {
        className: "u-els-debuttonize c-els-link c-els-link--image c-els-field__icon-".concat(alignment),
        onClick: callback,
        type: "button"
      }, /* @__PURE__ */React.createElement(Icon, _objectSpread({}, iconProps))) : /* @__PURE__ */React.createElement("span", {
        className: "c-els-field__icon-".concat(alignment)
      }, /* @__PURE__ */React.createElement(Icon, _objectSpread({
        isDecorative: true
      }, iconProps))))
    );
  };
  return /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
    className: wrapperClasses,
    id: "".concat(inputID, "-wrapper"),
    "data-testid": "text-input-wrapper"
  }, /* @__PURE__ */React.createElement("label", {
    className: labelClasses,
    htmlFor: inputID,
    id: "".concat(inputID, "-label")
  }, /* @__PURE__ */React.createElement("span", {
    className: labelTextClasses,
    id: "".concat(inputID, "-label-text")
  }, inputProps.required && /* @__PURE__ */React.createElement("span", {
    className: !hideRequired && "c-els-field__label-required-indicator"
  }, !hideRequired && /* @__PURE__ */React.createElement(React.Fragment, null, "*"), /* @__PURE__ */React.createElement("span", {
    className: "u-els-hide-visually"
  }, "(", requiredLabel, ")")), label), isTextArea ? /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__wrap"
  }, /* @__PURE__ */React.createElement("textarea", _objectSpread(_objectSpread(_objectSpread({}, sharedInputAttributes), {}, {
    rows: rows
  }, inputProps), {}, {
    onKeyDown: onKeyDownWrapper,
    style: textareaHeightStyles
  }))) : /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__wrap"
  }, /* @__PURE__ */React.createElement("input", _objectSpread(_objectSpread({}, sharedInputAttributes), {}, {
    type: isNumberInput ? "number" : "text",
    onWheel: isNumberInput ? blurInput : null
  }, inputProps)), iconLeft && renderIcon(iconLeft, iconLeftCallback, "left"), iconRight && renderIcon(iconRight, iconRightCallback, "right"), isSelectBox && renderChildren(children))), toolbar ? /* @__PURE__ */React.createElement("div", {
    className: "c-els-field__toolbar"
  }, toolbar) : null), !isSelectBox && renderChildren(children));
};
function renderChildren(children) {
  if (Children.count(children) <= 1) {
    return children;
  }
  throw new Error("TextInput only expected to receive a single React element child.");
}
TextInput.displayName = "TextInput";
TextInput.propTypes = {
  /** Height changes automatically as the user types */
  autoHeight: bool$3,
  /** Render element after input but within the input wrapper, intended for TextInputMessage */
  children: node$2,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string$3,
  /** Hides the required asterisk; used in InputDatePicker */
  hideRequired: bool$3,
  /** The props for the left Icon. Shape documented in that component */
  iconLeft: shape$1({}),
  /** Function to be called when left icon is clicked */
  iconLeftCallback: func$2,
  /** The props for the right Icon. Shape documented in that component */
  iconRight: shape$1({}),
  /** Function to be called when right icon is clicked */
  iconRightCallback: func$2,
  /**
   * id used for linking input and label elements.
   * If id is not provided a id will be generated from the label
   */
  id: string$3,
  /** A React ref applied to the input element */
  inputRef: object$1,
  /** Should the input render inline with the label */
  isLabelInline: bool$3,
  /** Should the input render as type=number */
  isNumberInput: bool$3,
  /** Flag showing component is being used within the Select component */
  isSelectBox: bool$3,
  /** Flag showing component is being used within the TextArea component */
  isTextArea: bool$3,
  /** The label for the input, required even if hidden for accessibility */
  label: string$3.isRequired,
  /** The maxHeight allowed for autoHeight */
  maxHeight: string$3,
  /** minHeight of the text area */
  minHeight: string$3,
  /**
   * Set label and input to read only.
   */
  readOnly: bool$3,
  /** Show a 'required' asterisk and associated hidden descriptive text */
  required: bool$3,
  /** An override for the hidden text denoting a required field */
  requiredLabel: string$3,
  /**
   * The number of text rows available to be filled;
   * Required because the TextArea component will always pass in a value
   */
  rows: number$3,
  /**
   * Accessibly hide the label.
   * If hidden, label will be used as the placeholder by default
   * which can be removed by passing an empty string as a placeholder.
   */
  shouldHideLabel: bool$3,
  /** Size of the text box or text area */
  size: string$3,
  /** Make space for an overlaid toolbar at the bottom of the input */
  toolbar: node$2,
  /** Callback function when the value changes */
  onChange: func$2
};
TextInput.requiredProps = {
  label: ValidPropTypes.STRING
};
TextInput.defaults = defaults$1;
TextInput.Message = TextInputMessage$1;
TextInput.Sizes = TextInputSizes;
var RawTextInput = TextInput;
var TextInput$1 = makeErrorBoundComponent(RawTextInput);
var bool$2 = PT.bool,
  func$1 = PT.func,
  node$1 = PT.node,
  number$2 = PT.number,
  string$2 = PT.string;
var NumberInput = function NumberInput(props) {
  return /* @__PURE__ */React.createElement(TextInput$1, _objectSpread(_objectSpread({}, props), {}, {
    isNumberInput: true
  }));
};
NumberInput.displayName = "NumberInput";
NumberInput.propTypes = {
  /** Render element after input but within the input wrapper, intended for TextInputMessage */
  children: node$1,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string$2,
  /**
   * id used for linking input and label elements.
   * If id is not provided a id will be generated from the label
   */
  id: string$2,
  /** Should the input render inline with the label */
  isLabelInline: bool$2,
  /** Flag showing component is being used within the Select component */
  isSelectBox: bool$2,
  /** The label for the input, required even if hidden for accessibility */
  label: string$2.isRequired,
  /**
   * Set label and input to read only.
   */
  readOnly: bool$2,
  /** Show a 'required' asterisk and associated hidden descriptive text */
  required: bool$2,
  /** An override for the hidden text denoting a required field */
  requiredLabel: string$2,
  /** The number of text rows available to be filled */
  rows: number$2,
  /**
   * Accessibly hide the label.
   * If hidden, label will be used as the placeholder by default
   * which can be removed by passing an empty string as a placeholder.
   */
  shouldHideLabel: bool$2,
  /** Callback function when the value changes */
  onChange: func$1
};
NumberInput.requiredProps = {
  label: ValidPropTypes.STRING
};
NumberInput.defaultProps = {
  children: null,
  className: "",
  id: "",
  isLabelInline: false,
  onChange: null,
  rows: 3,
  shouldHideLabel: false,
  required: false,
  isSelectBox: false,
  requiredLabel: "Required",
  readOnly: false
};
NumberInput.Message = TextInputMessage$1;
var RawNumberInput = NumberInput;
var NumberInput$1 = makeErrorBoundComponent(RawNumberInput);
var TextArea = function TextArea(props) {
  return /* @__PURE__ */React.createElement(TextInput$1, _objectSpread(_objectSpread({}, props), {}, {
    isTextArea: true
  }));
};
TextArea.displayName = "TextArea";
TextArea.propTypes = _objectSpread({}, TextInput$1.propTypes);
TextArea.requiredProps = {
  label: ValidPropTypes.STRING
};
TextArea.defaults = TextInput$1.defaults;
TextArea.Message = TextInputMessage$1;
var RawTextArea = TextArea;
var TextArea$1 = makeErrorBoundComponent(RawTextArea);
var CharacterCounterTypes = createEnum(['visual', 'oracleSqlServer']);
var ValidationTypes = createEnum(['alpha', 'alphanumeric', 'none', 'numeric', 'email']);
var ValidationModes = createEnum(['invalid', 'neutral', 'valid']);
var bool$1 = PT.bool,
  node = PT.node,
  number$1 = PT.number,
  string$1 = PT.string;
var defaults = {
  children: null,
  className: "",
  count: 0,
  id: null,
  maxChars: 0,
  showCount: false,
  countThreshold: 0
};
var CharacterCount = function CharacterCount(_ref3) {
  var _ref3$count = _ref3.count,
    count = _ref3$count === void 0 ? defaults.count : _ref3$count,
    _ref3$children = _ref3.children,
    children = _ref3$children === void 0 ? defaults.children : _ref3$children,
    _ref3$className = _ref3.className,
    className = _ref3$className === void 0 ? defaults.className : _ref3$className,
    _ref3$id = _ref3.id,
    id = _ref3$id === void 0 ? defaults.id : _ref3$id,
    _ref3$maxChars = _ref3.maxChars,
    maxChars = _ref3$maxChars === void 0 ? defaults.maxChars : _ref3$maxChars,
    _ref3$showCount = _ref3.showCount,
    showCount = _ref3$showCount === void 0 ? defaults.showCount : _ref3$showCount,
    _ref3$countThreshold = _ref3.countThreshold,
    countThreshold = _ref3$countThreshold === void 0 ? defaults.countThreshold : _ref3$countThreshold;
  var classes = classnames(className, "c-els-field__character-count");
  return showCount && maxChars > 0 && count >= countThreshold ? /* @__PURE__ */React.createElement("span", {
    className: classes,
    id: id,
    "data-testid": "character-count"
  }, children, /* @__PURE__ */React.createElement("span", {
    className: "c-els-field__character-count-label"
  }, "".concat(count, "/").concat(maxChars, " characters"))) : children;
};
CharacterCount.displayName = "CharacterCount";
CharacterCount.propTypes = {
  /** What to render in the CharacterCount as content, either text or HTML */
  children: node,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string$1,
  /** number of characters in the input value */
  count: number$1,
  /** Number of chars at and above which point the character count is shown */
  countThreshold: number$1,
  /** Unique ID */
  id: string$1,
  /** Maximum length an input value can be. Must be greater than 0 to display the count */
  maxChars: number$1,
  /** Controls whether the character count is displayed */
  showCount: bool$1
};
CharacterCount.requiredProps = {};
CharacterCount.defaults = defaults;
var bool = PT.bool,
  func = PT.func,
  number = PT.number,
  object = PT.object,
  oneOf = PT.oneOf,
  oneOfType = PT.oneOfType,
  shape = PT.shape,
  string = PT.string;
var ValidatedTextInput = /*#__PURE__*/function (_Component) {
  function ValidatedTextInput() {
    var _this;
    _classCallCheck(this, ValidatedTextInput);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ValidatedTextInput, [].concat(args));
    _defineProperty(_this, "state", {
      errorMessages: {},
      validity: ValidationModes.NEUTRAL,
      generatedId: generateId(),
      touched: false
    });
    // Users may provide partial `messages` props, and we fall back to the defaults for the other terms
    _defineProperty(_this, "compiledMessages", _objectSpread(_objectSpread({}, DefaultMessages), _this.props.messages));
    /**
     * Gets value from change event and trims whitespace.
     * Calls custom change handler with the original event and determined validity
     * @param {event} e - React synthetic event for onChange
     */
    _defineProperty(_this, "handleChange", function (e) {
      var onChange = _this.props.onChange;
      var validity = _this.validate(e.target.value.trim());
      if (onChange) {
        onChange(e, validity);
      }
    });
    /**
     * Runs each validation check and compiles them together into a single result
     * Updates the components `validity` state
     * @param {string} value - value from input event
     * @returns {string} - one of the ValidationModes
     */
    _defineProperty(_this, "validate", function (value) {
      var _this$props = _this.props,
        _this$props$errorMess = _this$props.errorMessageMap,
        _this$props$errorMess2 = _this$props$errorMess.max,
        maxErrorMessage = _this$props$errorMess2 === void 0 ? _this.compiledMessages.MAX_ERROR_MESSAGE : _this$props$errorMess2,
        _this$props$errorMess3 = _this$props$errorMess.min,
        minErrorMessage = _this$props$errorMess3 === void 0 ? _this.compiledMessages.MIN_ERROR_MESSAGE : _this$props$errorMess3,
        _this$props$errorMess4 = _this$props$errorMess.required,
        requiredErrorMessage = _this$props$errorMess4 === void 0 ? _this.compiledMessages.REQUIRED_ERROR_MESSAGE : _this$props$errorMess4,
        onlyValidateWhenTouched = _this$props.onlyValidateWhenTouched;
      var _this$validatePattern = _this.validatePattern(value),
        customValidity = _this$validatePattern.validity,
        customErrorMessage = _this$validatePattern.errorMessage;
      var maxLengthValidity = _this.validateMaxLength(value);
      var minLengthValidity = _this.validateMinLength(value);
      var requiredValidity = _this.validateRequiredLength(value);
      var validity = [customValidity, maxLengthValidity, minLengthValidity, requiredValidity].reduce(function (prev, curr) {
        if (prev === ValidationModes.INVALID || curr === ValidationModes.INVALID) {
          return ValidationModes.INVALID;
        }
        if (prev === ValidationModes.VALID || curr === ValidationModes.VALID) {
          return ValidationModes.VALID;
        }
        return ValidationModes.NEUTRAL;
      });
      if (!onlyValidateWhenTouched || onlyValidateWhenTouched && _this.state.touched) {
        _this.setState({
          errorMessages: {
            customValidity: customValidity === ValidationModes.INVALID ? customErrorMessage : null,
            required: requiredValidity === ValidationModes.INVALID ? requiredErrorMessage : null,
            max: maxLengthValidity === ValidationModes.INVALID ? maxErrorMessage : null,
            min: minLengthValidity === ValidationModes.INVALID ? minErrorMessage : null
          },
          validity: validity
        });
      }
      return validity;
    });
    /**
     * Validates that the given value string length isn't greater than the max prop
     * @param {string} value - string value to validate
     * @returns {string} - one of the ValidationModes
     */
    _defineProperty(_this, "validateMaxLength", function (value) {
      var max = _this.props.max;
      var validity = ValidationModes.VALID;
      if (!value) {
        validity = ValidationModes.NEUTRAL;
      } else if (_this.countStringLength(value) > max) {
        validity = ValidationModes.INVALID;
      }
      return validity;
    });
    /**
     * Validates that the given value string length is greater than the min prop
     * @param {string} value - string value to validate
     * @returns {string} - one of the ValidationModes
     */
    _defineProperty(_this, "validateMinLength", function (value) {
      var min = _this.props.min;
      var validity = ValidationModes.VALID;
      if (!value) {
        validity = ValidationModes.NEUTRAL;
      } else if (value.length < min) {
        validity = ValidationModes.INVALID;
      }
      return validity;
    });
    /**
     * Validates that the given value string length is greater than 0
     * @param {string} value - string value to validate
     * @returns {string} - one of the ValidationModes
     */
    _defineProperty(_this, "validateRequiredLength", function (value) {
      var required = _this.props.required;
      var validity = ValidationModes.VALID;
      if (!value) {
        validity = required ? ValidationModes.INVALID : ValidationModes.NEUTRAL;
      }
      return validity;
    });
    /**
     * Validates that the input matches the given pattern
     * @param {string} value - value from input event
     * @returns {string} - one of the ValidationModes
     */
    _defineProperty(_this, "validatePattern", function (value) {
      var validator = _this.props.validator;
      var isValid;
      var errorMessage;
      if (!value) {
        return ValidationModes.NEUTRAL;
      }
      switch (validator) {
        case ValidationTypes.NONE:
          isValid = true;
          break;
        case ValidationTypes.ALPHANUMERIC:
          isValid = /^[a-zA-Z0-9\s]*$/.test(value);
          errorMessage = _this.compiledMessages.ALPHANUMERIC_ERROR_MESSAGE;
          break;
        case ValidationTypes.ALPHA:
          isValid = /^[a-zA-Z\s]*$/.test(value);
          errorMessage = _this.compiledMessages.ALPHA_ERROR_MESSAGE;
          break;
        case ValidationTypes.NUMERIC:
          isValid = /^[0-9]*$/.test(value);
          errorMessage = _this.compiledMessages.NUMERIC_ERROR_MESSAGE;
          break;
        case ValidationTypes.EMAIL:
          isValid = /^([a-zA-Z0-9_\-\\.]+)@([a-zA-Z0-9_\-\\.]+)\.([a-zA-Z]{2,5})$/.test(value);
          errorMessage = _this.compiledMessages.EMAIL_ERROR_MESSAGE;
          break;
        default:
          if (typeof validator !== "function") {
            throw new TypeError("`validator` must be a function");
          }
          errorMessage = validator(value);
          isValid = !errorMessage;
          if (!!errorMessage && typeof errorMessage !== "string" && _typeof(errorMessage) !== "object") {
            throw new TypeError("Passed validator functions must return a string, JSX, or falsy value");
          }
          break;
      }
      return {
        validity: isValid ? ValidationModes.VALID : ValidationModes.INVALID,
        errorMessage: errorMessage
      };
    });
    _defineProperty(_this, "inputTouched", function (event) {
      var onlyValidateWhenTouched = _this.props.onlyValidateWhenTouched;
      var inputValue = event.target.value.trim();
      if (onlyValidateWhenTouched && !_this.state.touched) {
        _this.setState({
          touched: true
        }, function () {
          return _this.validate(inputValue);
        });
      }
    });
    _defineProperty(_this, "segmenter", typeof Intl.Segmenter === "function" ? new Intl.Segmenter(navigator.language, {
      granularity: "grapheme"
    }) : {
      segment: function segment(value) {
        return Array.from(value);
      }
    });
    _defineProperty(_this, "countStringLength", function (value) {
      var characterCounter = _this.props.characterCounter;
      switch (characterCounter) {
        case CharacterCounterTypes.ORACLE_SQL_SERVER:
          return Array.from(value).length;
        default:
          return _toConsumableArray(_this.segmenter.segment(value)).length;
      }
    });
    return _this;
  }
  _inherits(ValidatedTextInput, _Component);
  return _createClass(ValidatedTextInput, [{
    key: "componentDidMount",
    value:
    /**
     * Checks that instance length constraints are in range.
     * Validates initial value if provided
     */
    function componentDidMount() {
      var _this$props2 = this.props,
        max = _this$props2.max,
        min = _this$props2.min,
        value = _this$props2.value,
        onMountValidation = _this$props2.onMountValidation;
      if (max && min > max) {
        throw new RangeError("Min cannot be greater than max length of the input");
      }
      if (value || onMountValidation) {
        var validationValue = this.validate(value);
        if (onMountValidation) {
          onMountValidation(validationValue);
        }
      }
    }
    /**
     * If component is already mounted and if then value prop gets change,
     * Then it will check for validity of the updated value prop
     */
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var value = this.props.value;
      if (prevProps.value !== value) {
        this.validate(value);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        id = _this$props3.id,
        children = _this$props3.children,
        countThreshold = _this$props3.countThreshold,
        className = _this$props3.className,
        errorMessageMap = _this$props3.errorMessageMap,
        isTextArea = _this$props3.isTextArea,
        label = _this$props3.label,
        max = _this$props3.max,
        messages = _this$props3.messages,
        min = _this$props3.min,
        onMountValidation = _this$props3.onMountValidation,
        onlyValidateWhenTouched = _this$props3.onlyValidateWhenTouched,
        readOnly = _this$props3.readOnly,
        shouldHideErrorMessage = _this$props3.shouldHideErrorMessage,
        showCount = _this$props3.showCount,
        characterCounter = _this$props3.characterCounter,
        validator = _this$props3.validator,
        value = _this$props3.value,
        _onBlur = _this$props3.onBlur,
        inputProps = _objectWithoutProperties(_this$props3, _excluded2);
      if (errorMessageMap.max || errorMessageMap.min || errorMessageMap.required) {
        console.warn("ErrorMessageMap is deprecated, use internationalization messages instead");
      }
      var _this$state = this.state,
        _this$state$errorMess = _this$state.errorMessages,
        customErrorMessage = _this$state$errorMess.customValidity,
        requiredErrorMessage = _this$state$errorMess.required,
        maxErrorMessage = _this$state$errorMess.max,
        minErrorMessage = _this$state$errorMess.min,
        validity = _this$state.validity,
        generatedId = _this$state.generatedId;
      var ariaId = id || Case.kebab("".concat(label, " ").concat(generatedId));
      var classes = classnames(className, {
        "text-input--valid": validity === ValidationModes.VALID,
        "text-input--invalid c-els-field--error": validity === ValidationModes.INVALID
      });
      var errorMessage = requiredErrorMessage || minErrorMessage || maxErrorMessage || customErrorMessage;
      return /* @__PURE__ */React.createElement(TextInput$1, _objectSpread(_objectSpread({
        className: classes
      }, inputProps), {}, {
        onChange: this.handleChange,
        id: ariaId,
        isTextArea: isTextArea,
        "aria-describedby": !shouldHideErrorMessage && (errorMessage || children) ? "".concat(ariaId, "-message") : null,
        label: label,
        readOnly: readOnly,
        value: value,
        onBlur: function onBlur(event) {
          if (_onBlur) {
            _onBlur(event);
          }
          _this2.inputTouched(event);
        }
      }), /* @__PURE__ */React.createElement("div", {
        id: "".concat(ariaId, "-message")
      }, /* @__PURE__ */React.createElement(CharacterCount, {
        count: value ? this.countStringLength(value) : 0,
        maxChars: max,
        showCount: showCount,
        countThreshold: countThreshold
      }, !shouldHideErrorMessage && (errorMessage ? /* @__PURE__ */React.createElement(ValidatedTextInput.Message, {
        type: ValidatedTextInput.Message.Types.ERROR,
        id: "".concat(ariaId, "-message-inner"),
        messages: messages
      }, errorMessage) : children))));
    }
  }]);
}(Component);
ValidatedTextInput.displayName = "ValidatedTextInput";
ValidatedTextInput.propTypes = _objectSpread(_objectSpread({}, TextInput$1.propTypes), {}, {
  /** One of the supplied character counting function types */
  characterCounter: oneOf(CharacterCounterTypes.getAll()),
  /** Number of chars at and above which point the character count is shown */
  countThreshold: number,
  /**
   * DEPRECATED: max, min, and required are replaced by internationalization messages
   * Object used to override the default error messages for the included validators
   * @property {string} errorMessageMap.max - error message for a value length that's longer than the required maximum
   * @property {string} errorMessageMap.min - error message for a value length that's shorter than the required minimum
   * @property {string} errorMessageMap.required - error message for an empty required field
   */
  errorMessageMap: shape({
    max: string,
    min: string,
    required: string
  }),
  /** Max length input value can be. Accepts 0 as a value to turn off max check */
  max: number,
  /** Messages for internationalization */
  messages: object,
  /** Min length input value can be */
  min: number,
  /** Only validate after input has been blurred for the first time */
  onlyValidateWhenTouched: bool,
  /** Controls whether or not to hide the error message */
  shouldHideErrorMessage: bool,
  /** Controls the display of the character count */
  showCount: bool,
  /** One of the supplied functions, or a custom validation function */
  validator: oneOfType([oneOf(ValidationTypes.getAll()), func]),
  /** The application's onBlur callback */
  onBlur: func,
  /** onMountValidation function returns validity and validates the text on mount */
  onMountValidation: func
});
ValidatedTextInput.requiredProps = _objectSpread({}, TextInput$1.requiredProps);
ValidatedTextInput.defaultProps = _objectSpread(_objectSpread({}, TextInput$1.defaultProps), {}, {
  characterCounter: CharacterCounterTypes.VISUAL,
  countThreshold: 0,
  errorMessageMap: {},
  max: Infinity,
  messages: DefaultMessages,
  min: 0,
  onlyValidateWhenTouched: false,
  shouldHideErrorMessage: false,
  showCount: false,
  validator: ValidationTypes.ALPHANUMERIC,
  onBlur: null,
  onMountValidation: null
});
ValidatedTextInput.Message = TextInput$1.Message;
ValidatedTextInput.DefaultMessages = DefaultMessages;
ValidatedTextInput.Modes = ValidationModes;
ValidatedTextInput.Validators = ValidationTypes;
ValidatedTextInput.CharacterCounterTypes = CharacterCounterTypes;
var RawValidatedTextInput = ValidatedTextInput;
var ValidatedTextInput$1 = makeErrorBoundComponent(RawValidatedTextInput);
var ValidatedTextArea = function ValidatedTextArea(props) {
  return /* @__PURE__ */React.createElement(ValidatedTextInput$1, _objectSpread(_objectSpread({}, props), {}, {
    isTextArea: true
  }));
};
ValidatedTextArea.displayName = "ValidatedTextArea";
ValidatedTextArea.propTypes = _objectSpread({}, ValidatedTextInput$1.propTypes);
ValidatedTextArea.requiredProps = _objectSpread({}, ValidatedTextInput$1.requiredProps);
ValidatedTextArea.defaultProps = _objectSpread({}, ValidatedTextInput$1.defaultProps);
ValidatedTextArea.Message = TextInputMessage$1;
var RawValidatedTextArea = ValidatedTextArea;
var ValidatedTextArea$1 = makeErrorBoundComponent(RawValidatedTextArea);
export { NumberInput$1 as NumberInput, RawNumberInput, RawTextArea, RawTextInput, RawValidatedTextArea, RawValidatedTextInput, TextArea$1 as TextArea, TextInput$1 as TextInput, ValidatedTextArea$1 as ValidatedTextArea, ValidatedTextInput$1 as ValidatedTextInput };
